import React from "react";

import { useState } from "react";
import { Search } from "react-feather";

import Input from "../components/Input";
import Popup from "../components/Popup";
import FavLotesTable from "../components/FavLotesTable";
import { CButton } from "@coreui/react";

const FavLotes = () => {
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [searchData, setSearchData] = useState({});

  const [trigger, setTrigger] = useState(false);

  const search = () => {
    setSearchData({ name, title });
  }

  return (
    <div className="d-flex flex-column">
      <Popup title="Pesquisar" trigger={trigger} setTrigger={setTrigger} width="400">
        <div className="x-p-20 pb-20">
          <Input label="Nome" type="text" onChange={event => setName(event.target.value)} value={name} register={() => () => {}} />
          <Input label="Título do lote" type="text" onChange={event => setTitle(event.target.value)} value={title} register={() => () => {}} />

          <CButton color="primary" className="mt-20 w-100" onClick={search}>
            Pesquisar
          </CButton>
        </div>
      </Popup>

      <div className="header border-bottom border-top-right-radius-8">
        <span>Lotes favoritados</span>

        <div>
          <button className="dropdown__btn rounded__btn ml-10" style={{ width: "34px", height: "34px" }} onClick={() => setTrigger(!trigger)}>
            <Search size={18} />
          </button>
        </div>
      </div>

      <div className="dashboard__container-chart">
        <FavLotesTable searchData={searchData} />
      </div>
    </div >
  );
}

export default FavLotes;